<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.modal" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="modal" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.rounded" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="rounded" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <container align="center">
          <btn
            :bg-color="$root.colors.primary"
            :bg-color-lightness="$root.colors.bgColorLightness"
            color="white"
            icon-left="page-layout-footer"
            :color-lightness="null"
            @click="bottomSheets = !bottomSheets"
          >{{ $lang.toggleComponent(bottomSheets, 'Bottom Sheets') }}</btn>
        </container>
        <bottom-sheets @toggle="log('toggle', 'bottom-sheets', $event)" v-model="bottomSheets" :rounded="rounded" :modal="modal">
          <lorem-ipsum :repeats="3" />
          <container align="center">
            <btn
              :bg-color="$root.colors.primary"
              :class="['my-4']"
              :bg-color-lightness="$root.colors.bgColorLightness"
              color="white"
              icon-left="page-layout-footer"
              :color-lightness="null"
              @click="bottomSheets = !bottomSheets"
            >{{ bottomSheets ? 'Hide' : 'Show' }} Bottom Sheets</btn>
          </container>
        </bottom-sheets>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageBottomSheets',
  mixins: [
    methods
  ],
  data () {
    return {
      rounded: false,
      modal: false,
      bottomSheets: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/bottom-sheets.vue